<!-- Header -->
<app-header class="app-header"></app-header>

<!-- Side Navbar -->
<div class="wrp-main menu-container">
    <mat-sidenav-container class="sidenav-container" autosize>
        <mat-sidenav #sidenav class="sidenav-data" mode="side" opened="true">
            <mat-nav-list class="button-group" (click)="onButtonGroupClick($event)">
                <div class="yokahu-logo">
                    <img mat-card-sm-image *ngIf="isShowing" [src]="logoPath$ | async" alt=""
                    [class.yokahu-logo-img]="isDefaultLogo" (error)="onImgError($event)"
                    (load)="onMainLogoLoad($event)"
                    [class.not-default-logo]="!isDefaultLogo">
                    <img mat-card-sm-image *ngIf="!isShowing" [src]="smallLogoPath$ | async" alt=""
                    (load)="onSmallLogoLoad($event)"
                    [class.logo-small]="isDefaultSmallLogo" (error)="onSmallImgError($event)"
                    [class.not-default-logo-small]="!isDefaultSmallLogo">
                </div>
                <div style="margin-top: 10px;">
                    <mat-list-item [ngClass]="{'active': getActiveIndex == 0}" (click)="openclose(0)">
                        <mat-icon mat-list-icon>menu</mat-icon>
                        <span class="full-width" *ngIf="isShowing" [ngClass]="{'expanded' : isShowing }">Menu</span>
                    </mat-list-item>
                    <mat-list-item [ngClass]="{'active': getActiveIndex == 1}" (click)="search(1)">
                        <mat-icon mat-list-icon>image_search</mat-icon>
                        <span class="full-width" *ngIf="isShowing" [ngClass]="{'expanded' : isShowing }">Search</span>
                    </mat-list-item>
                    <mat-list-item [ngClass]="{'active': getActiveIndex == 7}" (click)="clients(7)">
                        <mat-icon mat-list-icon>people</mat-icon>
                        <span class="full-width" *ngIf="isShowing" [ngClass]="{'expanded' : isShowing }">Clients</span>
                    </mat-list-item>
                    <mat-list-item (click)="newRequest(2)" [ngClass]="{'active': getActiveIndex == 2}">
                        <mat-icon mat-list-icon>edit</mat-icon>
                        <span class="full-width" *ngIf="isShowing">{{router.url.includes('edit-request') ? 'Edit' : 'New'}}
                            request</span>
                    </mat-list-item>
                    <mat-list-item (click)="requests(3)" [ngClass]="{'active': getActiveIndex == 3}">
                        <mat-icon mat-list-icon>text_snippet</mat-icon>
                        <span class="full-width" *ngIf="isShowing">Requests</span>
                    </mat-list-item>
                    <mat-list-item (click)="nonBindingIndication(4)" [ngClass]="{'active': getActiveIndex == 4}">
                        <mat-icon mat-list-icon>done_all</mat-icon>
                        <span class="full-width" *ngIf="isShowing">Non-binding indications</span>
                    </mat-list-item>
                    <mat-list-item (click)="quoteRequested(8)" [ngClass]="{'active':getActiveIndex == 8}">
                        <mat-icon mat-list-icon>hourglass_empty</mat-icon>
                        <span class="full-width" *ngIf="isShowing">Quote Requested</span>
                    </mat-list-item>
                    <mat-list-item (click)="quote(5)" [ngClass]="{'active':getActiveIndex == 5}">
                        <mat-icon mat-list-icon>call_merge</mat-icon>
                        <span class="full-width" *ngIf="isShowing">Quotes</span>
                    </mat-list-item>
                    <mat-list-item (click)="bind(6)" [ngClass]="{'active': getActiveIndex == 6}">
                        <mat-icon mat-list-icon>verified_user</mat-icon>
                        <span class="full-width" *ngIf="isShowing">Bound</span>
                    </mat-list-item>
                    <mat-list-item (click)="underwriting(9)" [ngClass]="{'active': getActiveIndex == 9}">
                        <mat-icon mat-list-icon>rate_review</mat-icon>
                        <span class="full-width" *ngIf="isShowing">Underwriting</span>
                    </mat-list-item>
                </div>
            </mat-nav-list>
            <mat-nav-list> </mat-nav-list>
        </mat-sidenav>
        <div class="right-content">
            <router-outlet></router-outlet>
        </div>
    </mat-sidenav-container>
</div>